import ModalBox from '../utils/_modal-box.js';

export default function VideoModal() {
    new ModalBox('.open-video-modal');
}